export default "__VITE_ASSET__Di4QL$HS__"